import { mapGetters } from 'vuex'
import linkClicked from '@/utils/tracking/link-clicked'
import ozBreadcrumbDropdown from './oz-breadcrumb-dropdown'

export default {
  name: 'oz-breadcrumb',

  components: {
    ozBreadcrumbDropdown,
  },

  data () {
    return {
      isDropdownOpen: false,
    }
  },

  computed: {
    ...mapGetters({ breadcrumbWidget: 'page/breadcrumbWidget' }),

    breadcrumb () {
      return this.breadcrumbWidget?.links ?? []
    },

    firstLink () {
      return this.breadcrumb.length && this.breadcrumb[0]
    },

    breadcrumbList () {
      return this.breadcrumb.length > 1 ? this.breadcrumb.slice(1, this.breadcrumb.length) : []
    },

    showDropdown () {
      return this.breadcrumb.length > 2
    },
  },

  methods: {
    track (event) {
      this.$clickstream.trackEvent(linkClicked('breadcrumb', event.target.innerText))
    },
  },
}
